// Where the widget hands the patient over to the main site. The contract is
// documented in `docs/registration-handoff.md` of developer/new-express-doctor:
// a plain form POST carrying `full_name`, `phone` and `accept_terms`, which the
// site parks in a short-lived cookie before redirecting back with a relative
// `Location`.
// The site answers on a `ru.` subdomain while the widget is reached through a
// `ru-` prefix, so the RU host is configured rather than derived from the
// widget's own — the prefix logic in `api.ts` would produce `ru-express.doctor`.
function getSiteURL() {
    const isRuTunnel = window.location.hostname.startsWith(__RU_SITE_PREFIX__);
    const url = new URL(isRuTunnel ? __RU_SITE_URL__ : __SITE_URL__);
    // `wwwRedirectMiddleware` answers 301, and browsers downgrade POST to GET on
    // a 301: the body would be dropped and the handoff would fail silently.
    url.hostname = url.hostname.replace(/^www\./, "");
    return url.origin;
}
export function getHandoffURL(lang, doctorId) {
    const utm = new URLSearchParams({
        utm_source: "docref",
        utm_medium: "widget",
        utm_campaign: doctorId,
    });
    return `${getSiteURL()}/${lang}/register?${utm}`;
}
export function getOfferURL(lang) {
    return `${getSiteURL()}/${lang}/offer`;
}
export function getMainPageURL(lang) {
    const utm = new URLSearchParams({
        utm_source: "docref",
        utm_medium: "widget",
        utm_campaign: "broken_link",
    });
    return `${getSiteURL()}/${lang}?${utm}`;
}
